enum WellType {
    STANDARD = "STANDARD",
    POSITIVECONTROL = "POSITIVE CONTROL",
    NEGATIVECONTROL = "NEGATIVE CONTROL",
    LADDER = "LADDER"
};

export default WellType;